import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  signal,
  WritableSignal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAccordion } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { UIComponentsModule } from 'src/app/shared/ui-components/ui-components.module';
import { BaselineService } from '../baseline.service';
import { SnackbarService } from 'src/app/core/services/snackbar/snackbar.service';
import { FlightsComponent } from '../flights/flights.component';
import { userBaselineEntry } from 'src/app/shared/models/interfaces';

@Component({
  selector: 'app-baseline-category',
  imports: [
    MatAccordion,
    MatRadioModule,
    FormsModule,
    UIComponentsModule,
    FlightsComponent,
  ],
  templateUrl: './baseline-category.component.html',
  styleUrl: './baseline-category.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaselineCategoryComponent implements OnChanges {
  @Input() expandedQuestionIndex: WritableSignal<number> = signal(0);
  @Input() categoryName: string = '';
  @Input() questions: any[] = [];
  @Input() userEntries: userBaselineEntry[] = [];
  @Output() answerChanged = new EventEmitter<void>();

  constructor(
    private baselineService: BaselineService,
    private snackbarService: SnackbarService
  ) {}

  ngOnChanges() {
    this.questions.forEach((question) => {
      question.hasEntry = !!this.getUserAnswer(question.id);
    });
  }

  getUserAnswer(questionId: string): number | null {
    const entry = this.userEntries.find(
      (e) => e.baselineQuestionId === questionId
    );
    return entry ? entry.baselineAnswerId : null;
  }

  onAnswerChange(questionId: string, answerId: number) {
    const entry = this.userEntries.find(
      (e) => e.baselineQuestionId === questionId
    );
    if (entry) {
      this.baselineService
        .updateUserBaselineEntry({
          id: entry.id,
          baselineQuestionId: questionId,
          baselineAnswerId: answerId,
          updatedAt: new Date(),
        })
        .subscribe({
          next: () => {
            this.answerChanged.emit();
          },
          error: () => {
            this.snackbarService.showErrorMessage('Failed to update entry');
          },
        });
    } else {
      const newEntry: userBaselineEntry = {
        baselineQuestionId: questionId,
        baselineAnswerId: answerId,
      };
      this.baselineService.createUserBaselineEntry(newEntry).subscribe({
        next: () => {
          this.answerChanged.emit();
        },
        error: () => {
          this.snackbarService.showErrorMessage('Failed to create entry');
        },
      });
    }
  }

  setQuestionExpandedIndex(index: number) {
    this.expandedQuestionIndex.set(index);
  }

  nextQuestion() {
    this.expandedQuestionIndex.update(i => i + 1);
  }
}
